<template lang="pug">
.aiq-function-box
  .aiq-function-names-box
      aiq-select(placeholder="Functions",
              v-model="selectedFunctionName"
              class="select-dropdown")
          aiq-option(v-for="func in getFunctions",
                  :key="func.functionName"
                  :label="func.functionName"
                  :value="func.functionName")
      .aiq-function-delete-btn
          img(:src="iconClose" alt="close")
  .aiq-function-parameters-box(v-if="!selectedFunctionParameters.length < 1")
    aiq-select(placeholder="Parameters",
              multiple,
              class="select-dropdown",
              v-model="selectedParameters")
      aiq-option(v-for="param in selectedFunctionParameters",
              :key="param"
              :label="param"
              :value="param")
    .aiq-function-delete-btn
      img(:src="iconClose" alt="close")
</template>

<script>
import iconClose from '../assets/icon-close.svg';

export default {
  name: 'aiq-function-box',
  props: {
    list: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getFunctions() {
      return this.list.functions;
    },
  },
  data() {
    return {
      iconClose,
      selectedFunctionName: '',
      selectedFunctionParameters: [],
      selectedParameters: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.aiq-function-names-box {
  border: 1px solid #bfcbd9;
  border-radius: 4px;
  margin-bottom: 8px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  .aiq-function-delete-btn {
    flex: 0;
    min-width: 30px;
    text-align: center;
  }
}

.aiq-function-parameters-box {
  border: 1px solid #bfcbd9;
  border-radius: 4px;
  margin-left: 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: calc(100% - 20px);
  .aiq-function-delete-btn {
    flex: 0;
    min-width: 30px;
    text-align: center;
  }
}

.select-dropdown {
  flex: 1;
  padding: 8px 10px;
}
</style>
